"use strict";

import React from "react";
import LoadingSpinner from "../LoadingSpinner.jsx";

function DesignItemLoading(props) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <LoadingSpinner style={{ width: 24, height: 24 }} />
      <div style={{ padding: "6px" }}>Loading</div>
    </div>
  );
}

export default DesignItemLoading;
